<template>
    <div class="p-3 pt-4 lottery-page">
        <div>
            <table class="col-12">
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Name</th>
                        <!-- <th>Won Amount</th> -->
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(close, index) in closedDayList" :key="index">
                        <td>{{close.date}}</td>
                        <td>{{close.name}}</td>
                        <!-- <td>{{Number(user.won).toLocaleString()}} MMK</td> -->
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {
      closedDayList: []
    };
  },
  methods: {
    async closedDays(date) {
        try {
        const res = await axios.get('https://api.2dboss.com/api/lv/holiday_list');
        // console.log(res.data.data)
        this.closedDayList = res.data.data;
        } catch (error) {
        console.log(error);
        }
    },
  },
  mounted() {
    this.closedDays();
  },
};
</script>
<style scoped>
table {
        width: 100%;
        border-collapse: collapse;
        border-radius: 12px;
        overflow: hidden;
    }

    th,
    td {
        padding: 10px !important;
        background-color: #1c1c1c;
        color: #f0e6c8;
    }

    th {
        text-align: left;
    }

    thead {
        th {
            background: #2a2a2a;
            color: #d8c48a;
        }
    }

    tbody {
        tr {
            &:hover {
                background-color: #2a2a2a;
            }
        }
    }
</style>